if (!customElements.get('detect-overflow')) {
  class DetectOverflow extends HTMLElement {
    constructor() {
      super();

      this.checkOverflow = this.checkOverflow.bind(this)
    }

    checkOverflow() {
      if (this.scrollWidth > this.clientWidth) {
        this.classList.add('has-overflow');
      } else {
        this.classList.remove('has-overflow');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.checkOverflow);
      window.removeEventListener('resize', this.checkOverflow);
    }

    connectedCallback() {
      window.addEventListener('load', this.checkOverflow);
      window.addEventListener('resize', this.checkOverflow);

      this.checkOverflow();
    }
  }

  customElements.define('detect-overflow', DetectOverflow);
}